import axios from '../helpers/axiosConfig';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import * as Yup from 'yup';

function CreatEtsouservice() {
  const navigate = useNavigate();

  const initialValues = {
    name: '',
    libelle: '',
    obs: '',
    interne: '',
  };

  const validation = Yup.object().shape({
    name: Yup.string().required('Veuillez remplir '),
    libelle: Yup.string().required('Veuillez remplir '),
    obs: Yup.string().required('Veuillez remplir '),
  });

  const onSubmit = (data) => {
    axios.post('/etsouservice', data).then((res) => {
      console.log(res);
    });
    navigate('/etsouservice');
  };
  return (
    <div className="container mt-5 pt-5 ">
      <div className="bg-success p-3">Nouveau SERVICE, ETABLISSEMENT ou BUREAU</div>
      <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={validation}>
        <Form className="form-group">
          <div className="row">
            <div className="col">
              <label htmlFor="name"> Ets. ou service : </label>
              <ErrorMessage className="text-danger" name="name" component="span" />
              <Field id="name" name="name" className="form-control" />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <label htmlFor="obs"> Observation : </label>
              <ErrorMessage className="text-danger" name="obs" component="span" />
              <Field as="select" id="obs" name="obs" className="form-control">
                <option value=""></option>
                <option value="SERVICE">SERVICE</option>
                <option value="ETABLISSEMENT">ETABLISSEMENT</option>
                <option value="BUREAU">BUREAU</option>
              </Field>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <label htmlFor="libelle"> Libelle : </label>
              <ErrorMessage className="text-danger" name="libelle" component="span" />
              <Field id="libelle" name="libelle" className="form-control" />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <label htmlFor="interne"> Service ou ETS interne : </label>
              <ErrorMessage className="text-danger" name="interne" component="span" />
              <Field as="select" id="interne" name="interne" className="form-control">
                <option value="1">OUI</option>
                <option value="0">NON</option>
              </Field>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <button className="btn btn-primary mt-4" type="submit">
                Enregistrer
              </button>
            </div>
          </div>
        </Form>
      </Formik>
    </div>
  );
}

export default CreatEtsouservice;
